import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';
import { useTagsByAcademy } from '@/store/tags/useTagsByAcademy';

const CourseService = sdk.getService('CourseService');

export const useAllCoursesByAcademy = (academyIdOrSlug: string) => {
  const { tags = [] } = useTagsByAcademy(academyIdOrSlug);
  const { isLoading, data, error } = useQuery({
    queryKey: ['courses', 'by-tags', tags],
    queryFn: () => CourseService.findAllCoursesByTags(tags.map(tag => tag._id)),
    enabled: !!tags.length
  });

  return {
    courses: data,
    isLoading,
    error
  };
};
